import { PublicationSchema } from '@babyn-yar/schema';
import { API_URL } from '../context';
import { fetcher } from '../fetcher';
import { toSearchParams } from '../params';
import * as v from 'valibot';
export var PublicationAPI;
(function (PublicationAPI) {
    function list(filters) {
        const params = toSearchParams(filters);
        return fetcher(`${API_URL}/publications?${params}`);
    }
    PublicationAPI.list = list;
    function detail({ id, kind, locale }) {
        const params = toSearchParams({ kind, locale });
        return fetcher(`${API_URL}/publications/${id}?${params}`);
    }
    PublicationAPI.detail = detail;
    function create(input) {
        const body = v.parse(PublicationSchema.CreateInput, input);
        return fetcher(`${API_URL}/publications`, {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }
    PublicationAPI.create = create;
    function addTranslation({ id, expectedVersion, input }) {
        const body = v.parse(PublicationSchema.AddTranslationInput, input);
        return fetcher(`${API_URL}/publications/${id}/translations`, {
            method: 'POST',
            headers: { 'X-Expected-Version': String(expectedVersion) },
            body: JSON.stringify(body)
        });
    }
    PublicationAPI.addTranslation = addTranslation;
    function updateTranslation({ id, locale, expectedVersion, input }) {
        const body = v.parse(PublicationSchema.UpdateTranslationInput, input);
        return fetcher(`${API_URL}/publications/${id}/translations/${locale}`, {
            method: 'PATCH',
            headers: { 'X-Expected-Version': String(expectedVersion) },
            body: JSON.stringify(body)
        });
    }
    PublicationAPI.updateTranslation = updateTranslation;
    function removeTranslation({ id, locale }) {
        return fetcher(`${API_URL}/publications/${id}/translations/${locale}`, {
            method: 'DELETE'
        });
    }
    PublicationAPI.removeTranslation = removeTranslation;
})(PublicationAPI || (PublicationAPI = {}));
